import './PrimaryButton.css';
import Spinner from '../Spinner/Spinner';
import { Colors } from '../../lib/util';

interface PrimaryButtonProps {
  children?: string;
  loading: boolean;
  disabled?: boolean;
  color?: Colors;
  onClick: (e: React.MouseEvent) => void;
}

function PrimaryButton({
  loading,
  disabled,
  onClick,
  children,
  color,
}: PrimaryButtonProps): JSX.Element {
  function click(event: React.MouseEvent) {
    if (typeof onClick === 'function') {
      setTimeout(() => onClick(event), 200);
    }
  }
  return (
    <button
      className={`primary-button ${loading && 'loading'} ${color || Colors.Orange}`}
      onClick={click}
      disabled={disabled || loading}
    >
      <Spinner show={loading} />
      {children}
    </button>
  );
}

export default PrimaryButton;
